import React from "react";

const PageLoader = () => (
  <div className="d-flex justify-content-center align-items-center vh-100">
    <div className="rs-loader" role="status" aria-label="Loading" />
  </div>
);

export default PageLoader;
